import { c as _c } from "react/compiler-runtime";
import { GenericError, Button } from '@commutifi-fe/ui';
import { FormattedMessage } from 'locales/index';
import { logger } from '@commutifi-fe/logger';
export const handleDashboardError = (error: Error) => {
  logger.captureException(error, {
    operation: 'dashboard_error_boundary'
  });
};
export function DashboardErrorFallback(t0) {
  const $ = _c(6);
  const {
    error,
    reset
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FormattedMessage id="global.retry" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== reset) {
    t2 = [<Button key="retry" type="primary" onClick={reset}>{t1}</Button>];
    $[1] = reset;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== error || $[4] !== t2) {
    t3 = <GenericError type="page" error={error} actions={t2} />;
    $[3] = error;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}